
import App from '../main';
import Car from '../Sprites/Car'
import ControlPoint from '../Sprites/ControlPoint'
import { GamezopGame, GameZopSDK } from './libs/GameZopSDK';
import MapGenerator from './MapGenerator'
import UIManager from './UIManager';
import { GameConfig } from './Utils';

export class Game extends Phaser.Scene {

    public static car: Car;
    public static mapGenerator: MapGenerator;

    private static currentCpNumber: number = 0;
    public static currentGameDirection: Direction;
    public static currentControlPoint: ControlPoint;
    public static currentGameState: GameState;

    public static controlPointOutOfRange: boolean = false;
    private static inputDown: boolean = false;

    BGColors: Phaser.Display.Color[];
    public static uiScene: Phaser.Scene;

    score: number = 0;

    static cpDistantFromCar: boolean = true;
    public static currentFps: number = 0;
    public static isInput: boolean = false;

    public static enableCollisionLayer: number;
    public static disableCollisionLayer: number;

    public static sfxOn: boolean = true;
    public static bgmOn: boolean = true;

    public static isBattleMode: boolean;
    public static isSoundOn: boolean;
    public static battleModeTimer: number;
    public static camera: any;
    public static tween: any

    public static zoomOutCamera: number = 0.9;
    public static zoomInCamera: number = 1.2;


    public static firstTime: boolean;
    private fpsText: any;


    public static saveDataKey: string = "hammerplay_gzp_slingracer_data";

    constructor() {
        super('game');
    }

    init(data: any) {
        
    }

    preload() {
        App.gamezopSDK.setGameStateLoaded();
        this.time.delayedCall(2000, ()=> {
            if(App.gamezopSDK.isSDKLoaded) {
                Game.checkBattleMode();
                Game.checkAudio();
                this.scene.launch('ui');
            } else {
                console.log("SDK failed to load");
            }
        });
    }

    create() {

        window.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                this.game.sound.mute = true;
            } else {
                App.MUTE ? this.game.sound.mute = true : this.game.sound.mute = false;
            }
        })

        if (!this.game.device.browser) {
            document.getElementById("wrongRotation").style.display = "block";
        }

        var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
        if (isMobile != null) {
            if (window.screen.width < window.screen.height) {
                document.getElementById("wrongRotation").style.display = "none";
            } else {
                document.getElementById("wrongRotation").style.display = "block";
            }
        }

        // Set sprite properties
        App.mapData = this.game.cache.json.get("map");
        App.colliderData = this.game.cache.json.get("colliders");
        App.levelData = this.game.cache.json.get("wave");

        Game.currentGameDirection = Math.floor(Math.random() * 3);

        Game.enableCollisionLayer = this.matter.world.nextCategory();
        Game.disableCollisionLayer = this.matter.world.nextCategory();


        Game.mapGenerator = new MapGenerator(this);
        Game.car = new Car(this, this.cameras.main.width / 2, this.cameras.main.height / 2 + 300, 'car.png');
        Game.currentControlPoint = Game.mapGenerator.controlPoints[Game.currentCpNumber];

        // this.events.emit('menu');

        // Game.currentGameState = GameState.Menu;

        this.setBGColors();

        Game.uiScene = this.scene.get('ui');
        Game.uiScene.events.on('restart', () => {
            this.Restart()
        });
        Game.uiScene.events.on('toggleAudio', (bool) => {
            this.ToggleAudio(bool)
        })

        Game.uiScene.events.on('rewardLife', () => { this.OnCarCrash() });
        Game.uiScene.events.on('EndGame', () => { this.OnGameOver() });


        // this.cameras.main.setZoom(1.1)
        Game.camera = this.cameras;
        Game.tween = this.tweens;
        // this.fpsText = this.add.text(25, 200, 'FPS: ', { fontSize: '40px', fontStyle: 'bold',  fill: '#0f0' }).setOrigin(0,1);
        // this.fpsText.setScrollFactor(0);

        // this.cameras.main.setZoom(2)

        this.events.emit('updateLifeUI', App.totalLives);
        // this.game.loop.minFps = 60
        Game.tutorialPlayed();
        Game.setCameraZoom(Game.zoomOutCamera, false);

        if (App.gamezopSDK.isBattleGame()) {
            App.totalLives = 1;
        }
    }

    public static setCameraZoom(zoom: number, tween: boolean) {
        if (tween) {
            let tweenCamera: any
            tweenCamera = Game.tween.add({
                targets: Game.camera.main, ease: 'Cubic.In', duration: 700, zoom: zoom
            });
        }
        else {
            Game.camera.main.setZoom(zoom);
        }
    }

    public static tutorialPlayed() {
        if (localStorage.getItem('hammerplay_gzp_slingracer_visited') != '1') {
            Game.firstTime = true;
            localStorage.setItem('hammerplay_gzp_slingracer_visited', '1');

        } else {
            Game.firstTime = false;
        }

        // if (GameConfig.highScore == 0) {
        //     Game.firstTime = true;
        //     Game.SaveData();
        // } else {
        //     Game.firstTime = false;
        // }
    }

    public static SaveData() {
        let data = JSON.stringify(GameConfig);
        localStorage.setItem(this.saveDataKey, data);

    }

    public static loadSaveData() {
        if (!Object.keys(App.gamezopSDK.getMetadata()).length) {
            if (localStorage.getItem(this.saveDataKey) != null) {
                let savedData = (localStorage.getItem(this.saveDataKey));
                let gameConfig = JSON.parse(savedData);
                this.setData(gameConfig);
            }
            else {
                this.SaveData();
            }
        }
        else {
            let gameConfig = App.gamezopSDK.getMetadata();
            this.setData(gameConfig);
        }
    }

    public static setData(gameConfig: any) {
        GameConfig.highScore = gameConfig.highScore;
    }

    public static checkBattleMode() {
        if (App.gamezopSDK.isBattleGame()) {
            this.isBattleMode = true;
            Game.isInput = false;
        }
        else {
            this.isBattleMode = false;
            Game.isInput = true;
        }

    }


    public static checkAudio() {
        if (App.gamezopSDK.isSoundEnabled()) {
            this.isSoundOn = true;
        } else {
            this.isSoundOn = false;
        }
    }

    public battleMode_Timer() {
        var seconds: number = 120;
        var startingValue = { value: seconds };
        var endingValue = { value: 0 }
        let self = this;
        if (Game.isBattleMode) {
            Game.tween.add({
                targets: startingValue,
                value: endingValue,
                duration: seconds * 1000,
                ease: 'Linear',
                onUpdate: function (tween, target) {
                    // Game.battleModeTimer = Math.floor(target.value);
                    // UIManager.battleModeTimerText.setVisible(true);
                    // UIManager.battleModeTimerText.text = "Time: " + Math.floor(target.value).toString();
                },
                onComplete: function (tween, target) {
                    // self.OnGameOver();
                    // UIManager.battleModeTimerText.setVisible(false);
                }
            });
        }
    }

    static setCurrentControlPoint() {
        Game.currentControlPoint.inRange = true;
        Game.currentControlPoint.canLatch = true;
        Game.car.CPinRange();
    }

    static cpOutOfRange(controlPoint: ControlPoint) {
        Game.currentControlPoint.inRange = false;
        if (!this.inputDown) {
            this.UpdateCp();
        }
    }

    static onInputDown() {
        this.inputDown = true;
    }
    static onInputUp() {
        this.inputDown = false;
        if (!Game.currentControlPoint.inRange) {
            this.UpdateCp()
        }
        if (Game.car.canCourseCorrect) {
            this.UpdateCp()
        }
    }

    static CouseCorrect() {
        if (Game.currentGameState == GameState.Game) {
            Game.car.CourseCorrect();
            Game.currentControlPoint.AlphaTween(false);
            Game.currentControlPoint = Game.mapGenerator.controlPoints[++Game.currentCpNumber];
            this.cpDistantFromCar = true;
        }
    }

    static UpdateCp() {
        Game.currentControlPoint.canLatch = false;
    }

    IncreaseScore() {
        this.events.emit('addScore', ++this.score);
    }

    IncreaseStreakScore(score) {
        this.score += score;
        this.events.emit('addScore', ++this.score)
    }

    LevelUp() {
        Game.changeBG = true;
        //Game.zoom = true;
        // Game.zoomOut = true;
        Game.car.LevelUp();
        this.events.emit('levelUp')
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }

    update(time, deltaTime) {
        this.SetBackGroundColor();
        this.CameraZoom();
        Game.car.update(deltaTime);
        if (Game.cpDistantFromCar) {
            if (Game.car.DistanceBetweenCPandCar() < 500) {
                Game.cpDistantFromCar = false;
                Game.currentControlPoint.AlphaTween(true)
            }
        }
    }

    setBGColors() {
        this.cameras.main.setBackgroundColor(0x2196F3);

        this.BGColors = new Array();
        // this.BGColors.push(Phaser.Display.Color.HexStringToColor("#6fc9a2"))
        // this.BGColors.push(Phaser.Display.Color.HexStringToColor("#eeeef9"))
        // this.BGColors.push(Phaser.Display.Color.HexStringToColor("#e2a56d"))
        this.BGColors.push(Phaser.Display.Color.HexStringToColor("#00BCD4"))
        this.BGColors.push(Phaser.Display.Color.HexStringToColor("#FFEB3B"))
        this.BGColors.push(Phaser.Display.Color.HexStringToColor("#8BC34A"))
        this.BGColors.push(Phaser.Display.Color.HexStringToColor("#2196F3"))
    }

    static colorChangeValue: number = 0;
    static changeBG: boolean = true;
    static cameraZoom: number = 1;
    static zoom: boolean = false;
    static zoomOut: boolean = false;

    SetBackGroundColor() {
        if (Game.changeBG) {

            this.cameras.main.setBackgroundColor(Phaser.Display.Color.Interpolate.ColorWithColor(
                this.cameras.main.backgroundColor,
                this.BGColors[this.BGColors.length - 1],
                1, Game.colorChangeValue));

            if (Game.colorChangeValue < 0.99) {
                Game.colorChangeValue += 0.0025;
            } else {
                Game.colorChangeValue = 0;
                let color = this.BGColors.pop();
                this.BGColors.unshift(color);
                Game.changeBG = false;
            }
        }
    }


    CameraZoom() {
        if (Game.zoom) {
            this.cameras.main.setZoom(Game.cameraZoom)
            if (Game.cameraZoom > 0.75 && Game.zoomOut) {
                Game.cameraZoom -= 0.05;

            } else {
                Game.zoomOut = false;
                if (Game.cameraZoom < 0.77 && Game.cameraZoom > 0.75) {
                    Game.cameraZoom += 0.00025;
                } else {
                    Game.cameraZoom += 0.0075;
                    if (Game.cameraZoom > 0.95) {
                        Game.zoom = false;
                    }
                }
            }
            Game.cameraZoom = Phaser.Math.Clamp(Game.cameraZoom, 0.5, 1)
        }
    }

    OnPerfectTurn(count: number) {
        this.events.emit('perfectTurn', count);
        this.IncreaseScore();
    }

    OnGameOver() {
        this.events.emit('gameover');
        Game.isInput = false;
        Game.currentGameState = GameState.Gameover;
    }

    zoomout() {
        if (Game.cameraZoom > 0.1) {
            Game.cameraZoom -= 0.015;
            this.cameras.main.setZoom(Game.cameraZoom);
        }
    }

    Restart() {
        this.score = 0;
        Game.currentGameState = GameState.Menu;
        this.events.emit('menu');
        Game.currentCpNumber = 0;
        Game.currentGameDirection = Math.floor(Math.random() * 3);
        this.events.emit('restart');
        Game.currentControlPoint = Game.mapGenerator.controlPoints[Game.currentCpNumber]
        Game.controlPointOutOfRange = false;
        Game.cpDistantFromCar = true;
    }

    BeginGame() {
        this.events.emit('gameStart');
        Game.currentGameState = 1;
        this.battleMode_Timer();
        this.score = 0;
    }

    OnCarCrash() {
        App.vibrate(100);
        Game.car.Crash();
        App.totalLives--;
        // this.events.emit('updateLifeUI', App.totalLives);

        if (App.totalLives < 1) {
            this.events.emit('updateLifeUI', App.totalLives);
            Game.car.StopCar();
            this.time.addEvent({
                delay: 1500,
                callback: function () {
                    // this.events.emit('watchAD');
                    // App.totalLives++;
                    // console.log("Show Ad Screen");
                    if (!Game.isBattleMode) {
                        this.OnGameOver();
                    }
                },
                callbackScope: this
            })
        }
        else {
            Game.currentGameState = GameState.Respawn;
            Game.car.StopCar();
            this.events.emit('respawnUI', App.totalLives);

            this.time.addEvent({
                delay: 6000,
                callback: function () {
                    if (Game.currentGameState == GameState.Respawn) {
                        // this.events.emit('respawn');
                    }
                },
                callbackScope: this
            })
            // setTimeout(() => {
            //     if (Game.currentGameState == GameState.Respawn) {
            //         this.events.emit('respawn');
            //     }
            // }, 4050);
        }
    }

    ToggleAudio(bool: boolean) {
        Game.sfxOn = bool;
        Game.bgmOn = bool;
        Game.car.ToggleBGM(bool)
    }

}
export enum Direction { left, right, up, down }

export enum GameState { Menu, Game, Gameover, Respawn }



